import axios from 'axios'
import store from '@/store'

/**
 * Create new user
 * @param {Object} data Form data
 * @param {String} data.email Email address
 * @param {String} data.password Password
 * @param {String} data.passwordRepeat Password repeat
 */
function createAccount (data) {
  return axios
    .post('rest-auth/registration/', {
      username: data.email,
      email: data.email,
      password1: data.password,
      password2: data.passwordRepeat
    })
}

/**
 * Confirm user account email
 * @param {Object} data Form data
 * @param {String} data.token Confirmation token
 */
function confirmAccount (data) {
  return axios
    .get(`rest-auth/registration/account-confirm-email/${data.token}/`)
}

/**
 * Create coach profile
 * @param {Object} data Form data
 * @param {Boolean} data.membershipsBvc Member of _Bundesverband Coaching_
 * @param {Boolean} data.membershipsBvs Member of _Bundesverband Supervision_
 * @param {Boolean} data.membershipsOther Member of another certified coaching thing
 * @param {File} data.documentsCertificate Certificate PDF
 * @param {File} data.documentsTraining Training PDF
 * @param {File} data.image Portrait image
 * @param {Number} data.compensation Compensation
 * @param {String} data.address Street and number
 * @param {String} data.city City
 * @param {String} data.coreArea Biographical type of text
 * @param {String} data.firstName First name
 * @param {String} data.lastName Last name
 * @param {String} data.phone Phone number
 * @param {String} data.phoneMobile Mobile phone number
 * @param {String} data.postalCode Postal code
 * @param {String} data.website URL of website
 */
function createCoach (data) {
  const formData = new FormData()

  formData.append('user', store.state.user.meta.id)
  formData.append('first_name', data.firstName)
  formData.append('last_name', data.lastName)
  formData.append('telephone', data.phone)
  formData.append('mobile', data.phoneMobile)
  formData.append('address', data.address)
  formData.append('zip_code', data.postalCode)
  formData.append('town', data.city)
  formData.append('lichtbild', data.image)
  formData.append('rate', data.compensation)
  formData.append('homepage', data.website)
  formData.append('text', data.coreArea)
  formData.append('training', data.documentsTraining)
  formData.append('certificates', data.documentsCertificate)
  formData.append('qualification_bvc', data.membershipsBvc)
  formData.append('qualification_bvs', data.membershipsBvs)
  formData.append('qualification_other', data.membershipsOther)

  return axios
    .post('coaches/', formData)
}

/**
 * Create coachee profile
 * @param {Object} data Form data
 * @param {Number} data.position ID of position type
 * @param {Number} data.schoolType ID of school type
 * @param {String} data.firstName First name
 * @param {String} data.lastName Last name
 * @param {String} data.phone Phone number
 * @param {String} data.phoneMobile Mobile phone number
 * @param {String} data.school Name of school
 */
function createCoachee (data) {
  return axios
    .post('coachees/', {
      user: store.state.user.meta.id,
      first_name: data.firstName,
      last_name: data.lastName,
      telephone: data.phone,
      mobile: data.phoneMobile,
      job_title: data.position,
      school: data.school,
      school_type: data.schoolType
    })
}

export default {
  createAccount,
  confirmAccount,
  createCoach,
  createCoachee
}
